module.exports = __webpack_public_path__ + "static/img/9.7994b5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/17/9.png
// module id = v5Mk
// module chunks = 2